export const REQUEST_HARDWARE_SEARCH = "hardware.REQUEST_HARDWARE_SEARCH";
export const RECEIVE_HARDWARE_SEARCH = "hardware.RECEIVE_HARDWARE_SEARCH";
